import * as React from 'react';
import { styled } from '../../../../../theme';

interface ImageContainerProps {
	/** set the children of container */
	children: JSX.Element;
	/** set height */
	height: string;
	/** set margin */
	margin?: string;
}

const Image = styled.div`
	img {
		${(props: ImageContainerProps) => `height: ${props.height}`};
		max-width: 100%;
		margin: ${(props: ImageContainerProps) => props.margin || 'auto'};
	}
`;

const ImagePlaceholder = (props: ImageContainerProps) => {
	const { children } = props;

	return <Image {...props}>{children}</Image>;
};

export default ImagePlaceholder;
